/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoginAdminUserDto
 */
export interface LoginAdminUserDto {
    /**
     * Email
     * @type {string}
     * @memberof LoginAdminUserDto
     */
    email: string;
    /**
     * Password
     * @type {string}
     * @memberof LoginAdminUserDto
     */
    password: string;
}

/**
 * Check if a given object implements the LoginAdminUserDto interface.
 */
export function instanceOfLoginAdminUserDto(value: object): value is LoginAdminUserDto {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function LoginAdminUserDtoFromJSON(json: any): LoginAdminUserDto {
    return LoginAdminUserDtoFromJSONTyped(json, false);
}

export function LoginAdminUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginAdminUserDto {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'password': json['password'],
    };
}

export function LoginAdminUserDtoToJSON(value?: LoginAdminUserDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'password': value['password'],
    };
}

